import { ThemeOptions } from '@mui/material';

export const MuiSnackbarContent = (theme: ThemeOptions) => {
    return {
        styleOverrides: {
            root: {
                margin: 0,
                padding: 0,
            },
            message: {
                margin: 0,
                padding: 0,
            },
            action: {},
        },
    };
};
